var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.851,
    height: 32.851,
    viewBox: "0 0 32.851 32.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffffff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.213,26.122l-3.642-2.428-3.238-2.158a1.434,1.434,0,0,0-1.926.313l-2,2.575a1.427,1.427,0,0,1-1.822.378,23.325,23.325,0,0,1-6.514-5.019A23.492,23.492,0,0,1,8.05,13.269a1.427,1.427,0,0,1,.378-1.822l2.575-2a1.434,1.434,0,0,0,.313-1.926L9.224,4.38,6.73.639A1.434,1.434,0,0,0,4.8.2L1.922,1.93A3.515,3.515,0,0,0,.326,4c-.787,2.868-.945,9.2,9.195,19.336s16.467,9.981,19.335,9.194a3.514,3.514,0,0,0,2.066-1.6l1.726-2.877A1.434,1.434,0,0,0,32.213,26.122Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallwhite);
export default __webpack_public_path__ + "static/media/callwhite.af8eb6353832d99861e918975139c905.svg";
export { ForwardRef as ReactComponent };